"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasContent = hasContent;
exports.atMentionHtmlToToken = atMentionHtmlToToken;
exports.atMentionTokenToHtml = atMentionTokenToHtml;

var hasSupportedContent = function hasSupportedContent(block) {
  return block.getLength() > 0 || block.getType().indexOf('list-item') > -1 || block.getType() === 'atomic' && ['IMAGE', 'VIDEO'].includes(block.getData().get('atomicType'));
};

function hasContent(editorState) {
  return editorState.getCurrentContent().getBlockMap().some(hasSupportedContent);
}

function atMentionHtmlToToken(nodeName, node) {
  if (nodeName === 'span' && node.hasAttribute('data-at-mention')) {
    return {
      value: parseInt(node.getAttribute('data-owner-id'), 10),
      text: node.textContent
    };
  }

  return null;
} // Note, this data attribute format is shared with mobile.


function atMentionTokenToHtml(_ref) {
  var value = _ref.value,
      text = _ref.text;
  return "<span data-at-mention data-token data-owner-id=" + value + ">" + text + "</span>";
}